module.exports = __webpack_public_path__ + "img/2025-08-16d_3.8a8df4ff.jpg";